module.exports = __webpack_public_path__ + "static/media/thumbnail.671e44fd.jpg";